import { useEffect } from "react";
import Share from "lucide-react/dist/esm/icons/share";
import X from "lucide-react/dist/esm/icons/x";
import type { ManualInstallTarget } from "../use-pwa-install";

interface InstallSheetProps {
  open: boolean;
  target: ManualInstallTarget;
  onClose: () => void;
}

export function InstallSheet({ open, target, onClose }: InstallSheetProps) {
  useEffect(function manageInstallSheet() {
    if (!open) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    function closeOnEscape(event: KeyboardEvent) {
      if (event.key === "Escape") onClose();
    }
    window.addEventListener("keydown", closeOnEscape);
    return function restorePage() {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", closeOnEscape);
    };
  }, [open, onClose]);

  if (!open) return null;

  const device = target === "mac" ? "tu Mac" : target === "ipad" ? "tu iPad" : "tu iPhone";

  return (
    <div className="sheet-backdrop" role="presentation" onPointerDown={(event) => {
      if (event.target === event.currentTarget) onClose();
    }}>
      <section className="rules-sheet" role="dialog" aria-modal="true" aria-labelledby="install-title">
        <header>
          <div>
            <span className="eyebrow">CHIN · APP</span>
            <h2 id="install-title">Instalá CHIN en {device}</h2>
          </div>
          <button className="icon-button" type="button" onClick={onClose} aria-label="Cerrar instrucciones" autoFocus>
            <X aria-hidden="true" size={22} />
          </button>
        </header>

        <ol className="rule-list">
          <li>
            <b>Abrí CHIN en Safari</b>
            <p>Si estás dentro de otra app (WhatsApp, Instagram), tocá el menú y elegí "Abrir en Safari" — desde ahí no se puede instalar.</p>
          </li>
          <li>
            <b>Tocá Compartir <Share aria-hidden="true" size={15} strokeWidth={2.4} /></b>
            <p>{target === "mac"
              ? "Está en la barra de herramientas de Safari, arriba a la derecha."
              : "Es el cuadradito con la flecha hacia arriba en la barra de Safari."}</p>
          </li>
          <li>
            <b>{target === "mac" ? "Elegí \"Agregar al Dock\"" : "Elegí \"Agregar a pantalla de inicio\""}</b>
            <p>{target === "mac"
              ? "CHIN queda en el Dock como una app más."
              : "Deslizá la lista si no aparece, y confirmá con \"Agregar\"."}</p>
          </li>
        </ol>

        <div className="rules-note">
          <strong>¿Para qué?</strong>
          <p>Queda con su icono, abre a pantalla completa y carga al instante.</p>
        </div>

        <button className="primary-button" type="button" onClick={onClose}>Entendido</button>
      </section>
    </div>
  );
}
